import React, {useState} from 'react';
import {Button, Form, Input, Spin} from "antd";
import store from "../redux/store";
import {sendFeedbackAction} from "../redux/actions/pageActions";
import {Link} from "react-router-dom";
import {useMediaQuery} from "usehooks-ts";
import styled from "styled-components";

const StyledJoinTeamForm = styled.div`
    .ant-form {
        .ant-row {
            height: auto;
            max-height: none;
        }

        .ant-input {
            font-size: 20px;
            font-weight: 400;
            line-height: 140%;
            height: 61px;
            border-radius: 4px;
            font-family: Gilroy, Arial, sans-serif;
            padding: 22px 16px;
            min-width: 336px;

            &::placeholder {
                color: black;
            }
        }

        @media screen and (max-width: 999px) {
            .ant-form-item {
                margin-bottom: 0;

                &:not(:last-child) {
                    margin-bottom: 18px;
                }
            }

            .ant-input {
                font-size: 18px;
            }

            .ant-btn {
                width: 100%;
            }
        }
    }
`;
type JoinTeamFormType = {
    title: string,
    text: string,
}

function JoinTeamForm({title, text}: JoinTeamFormType) {
    const mobileSize = useMediaQuery('(max-width: 999px)')
    const [formRef] = Form.useForm();
    const [loading, setLoading] = useState(false);

    return (
        <StyledJoinTeamForm>
            <h2>{title}</h2>
            <p>{text}</p>
            <Spin spinning={loading}>
                <Form form={formRef} onFinish={({phone, name}) => {
                    setLoading(true);
                    store.dispatch(sendFeedbackAction({name, text: phone, email: ""})).then(() => {
                        formRef.resetFields();
                    }).finally(() => {
                        setLoading(false)
                    })
                    console.log({name, text: phone});
                }} layout={mobileSize ? "vertical" : "inline"}>
                    <Form.Item name={"name"} rules={[
                        {
                            required: true,
                            message: "Поле не может быть пустым!"
                        },
                    ]}>
                        <Input placeholder={"Как вас зовут?"}/>
                    </Form.Item>
                    <Form.Item name={"phone"} rules={[
                        {
                            required: true,
                            message: "Поле не может быть пустым!"
                        },
                    ]}>
                        <Input placeholder={"Номер телефона"}/>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType={"submit"}>Оставить заявку</Button>
                    </Form.Item>
                </Form>
            </Spin>
            <p>
                Оставляя заявку, вы соглашаетесь на обработку <Link to={"/doc/personal"}>персональных данных</Link>
            </p>
        </StyledJoinTeamForm>
    );
}

export default JoinTeamForm;